var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalCerdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 4,
    fill: "#FF383C",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3125 12.5V23.0625C26.3125 23.278 26.2269 23.4847 26.0745 23.637C25.9221 23.7894 25.7155 23.875 25.5 23.875C25.2845 23.875 25.0778 23.7894 24.9254 23.637C24.7731 23.4847 24.6875 23.278 24.6875 23.0625V14.4612L13.0748 26.0748C12.9223 26.2273 12.7156 26.313 12.5 26.313C12.2844 26.313 12.0776 26.2273 11.9251 26.0748C11.7727 25.9224 11.687 25.7156 11.687 25.5C11.687 25.2844 11.7727 25.0776 11.9251 24.9252L23.5388 13.3125H14.9375C14.722 13.3125 14.5153 13.2269 14.3629 13.0745C14.2106 12.9222 14.125 12.7155 14.125 12.5C14.125 12.2845 14.2106 12.0778 14.3629 11.9255C14.5153 11.7731 14.722 11.6875 14.9375 11.6875H25.5C25.7155 11.6875 25.9221 11.7731 26.0745 11.9255C26.2269 12.0778 26.3125 12.2845 26.3125 12.5Z",
    fill: "#FF383C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalCerdit);
export default __webpack_public_path__ + "static/media/total-cerdit.84cc2ffe798e7f37342dc8d1ace78767.svg";
export { ForwardRef as ReactComponent };